var OCS = OCS || {};
OCS.Data = OCS.Data || {};
OCS.Data.Advisories = OCS.Data.Advisories || {};
OCS.Advisories = OCS.Advisories || {};
OCS.Advisories.Functions = OCS.Advisories.Functions || {};

OCS.Advisories.Functions.get_active_adv = function (time) {
    var keys = Object.keys(OCS.Data.Advisories);
    var i = 0;
    var adv;
    var active = [];
    for(i; i<keys.length; i++) {
        adv = OCS.Data.Advisories[keys[i]];
        if(adv.is_active(time)) {
            active.push(adv);
        }
    }
    return active;
};

OCS.Advisories.Functions.get_active_adv_count = function (time) {
    return OCS.Advisories.Functions.get_active_adv(time).length;
};

/**
 * 
 * @param {String} phenom
 * @param {String} sig
 * @returns {OCS.Advisories.Config|.OCS.Advisories.Config|Class.Advisories.Config|nm$_base.OCS.Advisories.Config}
 */
OCS.Advisories.Functions.get_adv_config = function (phenom, sig) {
    var adv_id = phenom + sig;
    if (OCS.Advisories.Config[adv_id]) {
        return OCS.Advisories.Config[adv_id];
    }
};

/**
 * 
 * @param {String} phenom
 * @param {String} sig
 * @param {String} prop
 * @returns {OCS.Advisories.Config|.OCS.Advisories.Config|Class.Advisories.Config|nm$_base.OCS.Advisories.Config|nm$_base.OCS.Advisories.Functions.get_adv_config_prop.config}
 */
OCS.Advisories.Functions.get_adv_config_prop = function (phenom, sig, prop) {
    var config = OCS.Advisories.Functions.get_adv_config(phenom, sig);
    if (config && config[prop]) {
        return config[prop];
    }
    /* istanbul ignore next */
    return null;
};

OCS.Advisories.Functions.get_adv_count = function () {
    return Object.keys(OCS.Data.Advisories).length;
};


/**
 * @method get_adv_key - Returns the formatted advisory key
 * @param {String} nwso
 * @param {String} phenom
 * @param {String} sig
 * @param {String} etn
 * @param {String} year
 * @returns {String}
 */
OCS.Advisories.Functions.get_adv_key = function (nwso, phenom, sig, etn, year) {
    return nwso + "." + phenom + "." + sig + "." + etn + "." + year;
};

/**
 * 
 * @param {String} adv_key
 * @returns {OCS.Data.Advisories|Class.Data.Advisories|.OCS.Data.Advisories}
 */
OCS.Advisories.Functions.get_adv = function (adv_key) {
    if (OCS.Data.Advisories[adv_key]) {
        return OCS.Data.Advisories[adv_key];
    }
};
OCS.Advisories.Functions.get_advisory_data = function (properties) {
    return new OCS.Advisories.Classes.AdvisoryData(properties);
};

OCS.Advisories.Functions.get_nearest_time = function (adv_events, time) {
    if (adv_events.hasOwnProperty(time)) {
        return time;
    }
    var keys = OCS.Advisories.Functions.get_sorted_timestamp_keys(adv_events);
    if (time > keys[keys.length - 1]) {
        return keys[keys.length - 1];
    }
    for (var i = 0; i < keys.length; i++) {
        // Test that we are in step
        if (time < keys[i] && i > 0) {
            return keys[i - 1];
        }
        if (time > keys[i] && ((i + 1) < keys.length) && time < keys[i + 1]) {
            return keys[i];
        }
    }
    return false;
};


OCS.Advisories.Functions.get_previous_event_timestamp = function (adv_events, time) {
    var timestamp = OCS.Advisories.Functions.get_nearest_time(adv_events, time);
    var keys = OCS.Advisories.Functions.get_sorted_timestamp_keys(adv_events);
    var current_index = keys.indexOf(String(timestamp));
    if (current_index > 0) {
        return keys[current_index - 1];
    }
    return -1;
};
OCS.Advisories.Functions.get_sorted_timestamp_keys = function (adv_events) {
    var keys = Object.keys(adv_events);

        if (keys.length > 1) {
            keys.sort(function (a, b) {
                return a - b;
            });
        }

    return keys;
};

/**
 * Get the advisories that are active for a given time range
 *
 * @method get_advisories
 * @author Kenneth Jackson
 * @param start {Int} Start time.
 * @param end {Int} End time.
 * @param wfo_ids {Array} Weather forecast offices of interest.
 * @param warning_types {Array} warning types of interest.
 * @return {array} An array of all the active advisory objects.
 */
OCS.Advisories.Functions.retrieve_advisory_data = function(start, end, wfo_ids, warning_types) {
    var active_advisories = [];
    if(!start || !end || end < start) {
        return active_advisories;
    }
    if(!wfo_ids || !wfo_ids.length) {
        wfo_ids = ["*"];
    }
    if(!warning_types || !warning_types.length) {
        warning_types = ["*"];
    }

    var i, data_keys, key, d, adv_config;
    if (OCS.Advisories.Functions.get_adv_count()) {
        active_advisories = [];
        data_keys = Object.keys(OCS.Data.Advisories);
        for (i = 0; i < data_keys.length; i++) {
            key = data_keys[i];
            d = OCS.Advisories.Functions.get_adv(key);
            if (!d.is_contained(start, end)) {
                // Not active within the requested period
                continue;
            }

            // If we are looking for specific weather forecast offices and the advisory does not apply skip it.
            if (wfo_ids !== undefined && (!wfo_ids.includes("*") && !wfo_ids.includes(d.get_wfo_id()))) {
                continue;
            }

            // If we are looking for specific advisory types and the advisory does not apply skip it.
            adv_config = d.get_adv_config();
            if (warning_types !== undefined && warning_types.length && !warning_types.includes("*") && !warning_types.includes(adv_config.type)) {
                continue;
            }
            active_advisories.push(key);
        }
    }
    return active_advisories;
};





OCS.Advisories.Functions.store_advisory_data = function (properties, events) {
    var adv_data = new OCS.Advisories.Classes.AdvisoryData(properties);
    if (adv_data.is_new) {
        adv_data.is_new = false;
        if(events) {
            adv_data.addEvents(events);
        }
    }
    return adv_data;
};


/* istanbul ignore next */
try {
    if (typeof (module) !== 'undefined') {
        module.exports = {
            "get_adv": OCS.Advisories.Functions.get_adv,
            "get_adv_config": OCS.Advisories.Functions.get_adv_config,
            "get_adv_config_prop": OCS.Advisories.Functions.get_adv_config_prop,
            "get_adv_key": OCS.Advisories.Functions.get_adv_key

        };
    }
} catch (e) {

}